import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
export function Piercing() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="pt-32 pb-24 bg-white min-h-screen" data-id="element-649">
      <div className="container mx-auto px-6 md:px-12" data-id="element-650">
        {/* HERO SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto text-center mb-20" data-id="element-651">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-ink mb-6" data-id="element-652">
            Прокол вух
          </h1>
          <p className="text-muted text-lg md:text-xl font-normal leading-relaxed" data-id="element-653">
            Швидкий та безпечний прокол мочок вух для дорослих і дітей за
            допомогою пістолету з стерильними сережками.
          </p>
        </motion.div>

        {/* HOW IT WORKS */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="max-w-3xl mx-auto mb-16" data-id="element-654">
          <div className="grid gap-6" data-id="element-655">
            {['Консультація та вибір прикраси', 'Обробка антисептиком', 'Прокол пістолетом — швидко та безболісно'].map((item, i) => <div key={i} className="bg-white p-6 rounded-[2rem] border border-line shadow-sm flex items-center" data-id="element-656">
                <div className="w-12 h-12 bg-surface rounded-full border border-line flex items-center justify-center text-ink font-semibold text-lg mr-6 flex-shrink-0" data-id="element-657">
                  {i + 1}
                </div>
                <p className="text-ink font-medium text-lg" data-id="element-658">{item}</p>
              </div>)}
          </div>
        </motion.div>

        {/* SAFETY BLOCK */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="max-w-3xl mx-auto mb-16" data-id="element-659">
          <div className="bg-surface p-8 rounded-[2rem] border border-line" data-id="element-660">
            <h3 className="text-xl font-semibold text-ink mb-6" data-id="element-661">
              Безпека — наш пріоритет
            </h3>
            <ul className="space-y-4" data-id="element-662">
              {['Стерильні сережки-гвоздики з медичного золота', 'Одноразові матеріали', 'Підходить для дітей та дорослих', 'Швидкий процес без зайвого дискомфорту'].map((item, i) => <li key={i} className="flex items-start" data-id="element-663">
                  <div className="bg-white p-1 rounded-full border border-line mr-4 mt-0.5 shadow-sm" data-id="element-664">
                    <Check className="text-ink flex-shrink-0" size={14} strokeWidth={3} data-id="element-665" />
                  </div>
                  <span className="text-ink font-medium text-base" data-id="element-666">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        {/* PRICE */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="max-w-3xl mx-auto mb-24 text-center" data-id="element-667">
          <div className="bg-white p-12 rounded-[2rem] border border-line shadow-sm" data-id="element-668">
            <p className="text-muted text-sm uppercase tracking-widest font-medium mb-4" data-id="element-669">
              Вартість процедури
            </p>
            <p className="font-heading text-5xl md:text-6xl font-bold text-ink" data-id="element-670">
              350 грн
            </p>
          </div>
        </motion.div>

        {/* CTA SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="max-w-md mx-auto flex flex-col gap-4" data-id="element-671">
          <a href="/#contact" className="w-full py-4 bg-ink text-white text-center text-sm font-medium tracking-wide rounded-full hover:bg-black transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-672">
            Записатися
          </a>
          <Link to="/#services" className="w-full py-4 border border-line text-ink text-center text-sm font-medium tracking-wide rounded-full hover:bg-surface transition-all duration-300" data-id="element-673">
            До всіх послуг
          </Link>
        </motion.div>
      </div>
    </main>;
}